import React from 'react';
import styled from 'styled-components';
import PageTransition from 'gatsby-v2-plugin-page-transitions';

import Page from '../components/global/page';
import ContactTemplate from '../templates/contact-template';

const StyledPage = styled.div`
	.inner nav.pages ul li:not(.button-link) a {
		&.contact {
			font-weight: 700;
		}
	}
`;

const ContactPage = () => (
	<PageTransition>
		<StyledPage>
			<Page
				title="Contact"
				desc="Call us, email us, or fill out our form to get more info about mental health, to dontate to initiativers in your community or to host a Start Talking event!"
			>
				<ContactTemplate />
			</Page>
		</StyledPage>
	</PageTransition>
);

export default ContactPage;
